/**
 * @generated SignedSource<<61f82340d576a7576a399b76959dff7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type coachScreen_Query$variables = {
  coachProfileId: string;
};
export type coachScreen_Query$data = {
  readonly node: {
    readonly coach?: {
      readonly email: string;
      readonly extension: {
        readonly avatar?: {
          readonly thumbnail: string | null;
          readonly url: string | null;
        } | null;
        readonly firstName?: string;
        readonly lastName?: string;
        readonly position?: string | null;
      } | null;
      readonly name: string;
    } | null;
    readonly id?: string;
    readonly profileData?: {
      readonly description: string | null;
      readonly jobTitles: ReadonlyArray<string> | null;
      readonly quote: string | null;
      readonly socials: {
        readonly facebook: string | null;
        readonly linkedIn: string | null;
        readonly others: ReadonlyArray<string> | null;
        readonly twitter: string | null;
        readonly website: string | null;
      } | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"socialsCard_CoachProfileFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"myCoachings_QueryFragment">;
};
export type coachScreen_Query = {
  response: coachScreen_Query$data;
  variables: coachScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "coachProfileId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "coachProfileId",
    "variableName": "coachProfileId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "coachProfileId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quote",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jobTitles",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileDataSocials",
  "kind": "LinkedField",
  "name": "socials",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "facebook",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "linkedIn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "twitter",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "website",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "others",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v10 = [
  {
    "kind": "Literal",
    "name": "userExtensionKind",
    "value": "Academies"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v17 = [
  (v11/*: any*/),
  (v12/*: any*/),
  (v3/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "coachScreen_Query",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "myCoachings_QueryFragment"
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileData",
                "kind": "LinkedField",
                "name": "profileData",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "coach",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "extension",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "type": "AcademiesUserExtension",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": "extension(userExtensionKind:\"Academies\")"
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "socialsCard_CoachProfileFragment"
              }
            ],
            "type": "CoachProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "coachScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CoachingQueries",
        "kind": "LinkedField",
        "name": "Coaching",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CoachingOfferConnection",
            "kind": "LinkedField",
            "name": "CoachingOffersToCoach",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CoachingOfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CoachingOffer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachingOfferDescription",
                        "kind": "LinkedField",
                        "name": "description",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortDescription",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": true,
                            "selections": [
                              (v16/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AcademiesTagData",
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "image",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isTaxFree",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "netPrice",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extensions",
                                "plural": true,
                                "selections": [
                                  (v16/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "deGrossPrice",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "atGrossPrice",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "chGrossPrice",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AcademiesProductExtension",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "setting",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CoachProfile",
                        "kind": "LinkedField",
                        "name": "associatedCoaches",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "coach",
                            "plural": false,
                            "selections": [
                              (v8/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "licenseAvailability",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "numAvailable",
                                "storageKey": null
                              }
                            ],
                            "type": "LicenseAvailabilityFreeLicensesAvailable",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileData",
                "kind": "LinkedField",
                "name": "profileData",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "avatar",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "coach",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "extension",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "File",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": (v17/*: any*/),
                            "storageKey": null
                          },
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sumGamificationPoints",
                            "storageKey": null
                          }
                        ],
                        "type": "AcademiesUserExtension",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": "extension(userExtensionKind:\"Academies\")"
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "CoachProfile",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f60a61b94773d612f40ceb53c45f278d",
    "id": null,
    "metadata": {},
    "name": "coachScreen_Query",
    "operationKind": "query",
    "text": "query coachScreen_Query(\n  $coachProfileId: ID!\n) {\n  ...myCoachings_QueryFragment_4482oP\n  node(id: $coachProfileId) {\n    __typename\n    ... on CoachProfile {\n      id\n      profileData {\n        description\n        quote\n        jobTitles\n        socials {\n          facebook\n          linkedIn\n          twitter\n          website\n          others\n        }\n      }\n      coach {\n        name\n        email\n        extension(userExtensionKind: Academies) {\n          __typename\n          ... on AcademiesUserExtension {\n            avatar {\n              thumbnail\n              url\n              id\n            }\n            firstName\n            lastName\n            position\n          }\n        }\n        id\n      }\n      ...socialsCard_CoachProfileFragment\n    }\n    id\n  }\n}\n\nfragment coachingOfferCard_CoachingOfferFragment on CoachingOffer {\n  id\n  description {\n    name\n    description\n    shortDescription\n    tags {\n      __typename\n      id\n      data {\n        name\n      }\n    }\n    image {\n      thumbnail\n      url\n      id\n    }\n    product {\n      ...offerCard_ProductFragment\n      id\n    }\n  }\n  setting {\n    __typename\n    kind\n  }\n  associatedCoaches {\n    coach {\n      name\n      id\n    }\n    id\n  }\n  licenseAvailability {\n    __typename\n    ... on LicenseAvailabilityFreeLicensesAvailable {\n      numAvailable\n    }\n  }\n}\n\nfragment myCoachings_QueryFragment_4482oP on Query {\n  Coaching {\n    CoachingOffersToCoach(coachProfileId: $coachProfileId) {\n      edges {\n        node {\n          id\n          ...coachingOfferCard_CoachingOfferFragment\n        }\n      }\n    }\n  }\n}\n\nfragment offerCard_ProductFragment on Product {\n  isTaxFree\n  netPrice\n  extensions {\n    __typename\n    kind\n    ... on AcademiesProductExtension {\n      deGrossPrice\n      atGrossPrice\n      chGrossPrice\n    }\n  }\n}\n\nfragment socialsCard_CoachProfileFragment on CoachProfile {\n  id\n  coach {\n    name\n    email\n    extension(userExtensionKind: Academies) {\n      __typename\n      ... on AcademiesUserExtension {\n        firstName\n        lastName\n      }\n    }\n    ...userAvatar_UserFragment\n    id\n  }\n  profileData {\n    avatar {\n      url\n      id\n    }\n    description\n    jobTitles\n    socials {\n      others\n      linkedIn\n      facebook\n      twitter\n      website\n    }\n  }\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "882bb3b647d7efeb950ed9bad1bdd0b0";

export default node;
